import React from "react";
import LearningStepAttachmentDetails from "./LearningStepAttachmentDetails";

const LearningStepAttachmentDetailsWrapper = (props) => {
  console.log("props--->", props);
  console.log("Hello form wrapper");
  return (
    <div>
      {/* <p>Hello from Learning wrapper</p> */}
      <LearningStepAttachmentDetails key={props.location.pathname} {...props} />
    </div>
  );
};

export default LearningStepAttachmentDetailsWrapper;
